import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  ACCOUNT,
  ACCOUNT_CREATE,
  ACCOUNT_DELETE,
  ACCOUNT_LIST,
  ACCOUNT_PASSWORD_RESET,
  ACCOUNT_PROFILE_PIC,
  ACCOUNT_PROFILE_UPDATE,
  ACCOUNT_REQUIRED_ACTIONS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const account = createAsyncThunk(
  ACCOUNT,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.account(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountCreate = createAsyncThunk(
  ACCOUNT_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.accountCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountDelete = createAsyncThunk(
  ACCOUNT_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.accountDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountList = createAsyncThunk(
  ACCOUNT_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.accountList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountPasswordReset = createAsyncThunk(
  ACCOUNT_PASSWORD_RESET,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT_PASSWORD_RESET}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.accountPasswordReset(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountRequiredActions = createAsyncThunk(
  ACCOUNT_REQUIRED_ACTIONS,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT_REQUIRED_ACTION}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.accountRequiredAction(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountProfilePic = createAsyncThunk(
  ACCOUNT_PROFILE_PIC,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT_PROFILE_PIC}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.accountProfilePic(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountProfileUpdate = createAsyncThunk(
  ACCOUNT_PROFILE_UPDATE,
  async (params: PayloadCreatorParams<`/${typeof API.ACCOUNT_PROFILE_UPDATE}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.accountProfileUpdate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const accountListClear = createAction(`${ACCOUNT_LIST}/clear`)
